import { useEffect } from "react";

/**
 * Loads the Flowbiz (BYM Digital) chatbot widget.
 * The widget injects its own floating launcher button, so we don't render any UI here.
 */
export default function ChatbotWidget() {
  useEffect(() => {
    // Load the widget after the page has rendered (first interaction or ~4s),
    // so its script doesn't compete with the page's own loading.
    let timer;
    const load = () => {
      cleanup();
      if (document.querySelector('script[data-chatbot-id="8"]')) return;
      const s = document.createElement("script");
      s.src = "https://app.bymdigital.com/chatbot_widget.js";
      s.setAttribute("data-chatbot-id", "8");
      s.async = true;
      document.body.appendChild(s);
    };
    const events = ["pointerdown", "keydown", "scroll", "touchstart"];
    const cleanup = () => {
      clearTimeout(timer);
      events.forEach((e) => window.removeEventListener(e, load));
    };
    events.forEach((e) => window.addEventListener(e, load, { once: true, passive: true }));
    timer = setTimeout(load, 4000);
    return cleanup;
  }, []);

  return null;
}
